import React from "react";
import { Upload, Icon, Input, InputNumber, Row, Col, message, Tabs } from 'antd';
import { createUuid } from '../../../../utils/NHCore';
const TabPane = Tabs.TabPane;

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewVisible: false,
            previewImage: '',
            fileList: [],
            err: false,
            formData: {
                activeKey: 'img_tab',
                src: undefined,
                attachmentId: undefined,
                width: undefined,
                height: undefined
            }
        }
    }

    validateFields = (callback) => {
        let { err, formData } = this.state;
        if (formData.activeKey == 'src_tab') {
            if (!formData.src) {
                err = true;
                message.error("链接地址不能为空！");
            }
        } else {
            if (!formData.attachmentId) {
                err = true;
                message.error("请上传图片！");
            }
        }
        if (callback) {
            callback(err, formData);
        }
    }
    changeNumber = (name, value) => {
        let formData = this.state.formData;
        formData[name] = value;
        this.setState(formData);
    }
    handleChange = ({ fileList }) => {
        console.log(fileList);
        let formData = this.state.formData;
        if (fileList && fileList.length == 1 && fileList[0].response && fileList[0].response.data && fileList[0].response.meta.statusCode == 200) {
            formData["attachmentId"] = fileList[0].response.data.ssbh;
            this.setState({
                formData: formData,
                fileList: fileList
            });
        } else {
            formData["attachmentId"] = undefined;
            this.setState({
                formData: formData,
                fileList: fileList
            });
        }
    }
    beforeUpload = (file) => {
        if (file.type == "") {
            if (file.name.indexOf(".png") == -1 && file.name.indexOf(".PNG") == -1 &&
                file.name.indexOf(".jpg") == -1 && file.name.indexOf(".JPG") == -1 &&
                file.name.indexOf(".bpm") == -1 && file.name.indexOf(".BPM") == -1 &&
                file.name.indexOf(".gif") == -1 && file.name.indexOf(".GIF") == -1) {
                message.error('只能上传图片文件！');
                return false;
            } else {
                return true;
            }
        } else {
            let valid = file.type.indexOf('image') != -1;
            if (!valid) {
                message.error('只能上传图片文件！');
            }
            return valid;
        }
    }


    render() {
        const { previewVisible, previewImage, fileList } = this.state;
        const uploadProps = {
            name: 'file',
            action: 'api/docrepo/upload',
            beforeUpload: this.beforeUpload,
            data: { uuid: createUuid(), type: '1' },
            accept: 'image/*'
        }
        const footerDiv = <div>
            <Row style={{ marginBottom: 20 }}>
                <Col span={8} style={{ textAlign: 'right' }}>图片宽度：</Col>
                <Col span={12}><InputNumber value={this.state.formData.width} onChange={(value) => {
                    this.changeNumber("width", value);
                }} /></Col>
            </Row>
            <Row style={{ marginBottom: 20 }}>
                <Col span={8} style={{ textAlign: 'right' }}>图片高度：</Col>
                <Col span={12}><InputNumber value={this.state.formData.height} onChange={(value) => {
                    this.changeNumber("height", value);
                }} /></Col>
            </Row>
        </div>
        return (
            <Tabs activeKey={this.state.formData.activeKey} onChange={(activeKey) => {
                this.changeNumber("activeKey", activeKey);
            }}>
                <TabPane tab="本地上传" key="img_tab">
                    <Row style={{ marginBottom: 20 }}>
                        <Col span={8} style={{ textAlign: 'right' }}><font color='red'>*</font>上传图片：</Col>
                        <Col span={12}>
                            <Upload {...uploadProps} fileList={fileList}
                                onChange={this.handleChange}>
                                {fileList.length > 0 ? null : <div style={{
                                    textAlign: 'center', border: '1px solid #D9D9D9',
                                    width: '80px', height: '84px', lineHeight: '38px', cursor: 'pointer'
                                }}>
                                    <Icon type="plus" />
                                    <div>上传</div>
                                </div>}
                            </Upload>
                        </Col>
                    </Row>
                    {footerDiv}
                </TabPane>
                <TabPane tab="图片链接" key="src_tab">
                    <Row style={{ marginBottom: 20 }}>
                        <Col span={8} style={{ textAlign: 'right' }}><font color='red'>*</font>图片链接：</Col>
                        <Col span={12}><Input value={this.state.formData.src} onChange={(e) => {
                            this.changeNumber("src", e.target.value);
                        }} /></Col>
                    </Row>
                    {footerDiv}
                </TabPane>
            </Tabs>
        );
    }
}

export default EditInitForm;


// WEBPACK FOOTER //
// ./components/common/NHUeditor/img/EditForm.js